<div class="copyright">
    <div class="container">
        <p>Todos os direitos reservados - <strong>{{config.nome}}</strong> - 2024 | Desenvolvido por <a href="https://digitalmovement.com.br/" title="Digital Movement - Agência Digital" target="_blank">Digital Movement <img src='/images/digital-movement/logo.svg' alt="Digital Movement - Agência Digital" width="20px" height="20px"  /></a></p>
    </div>    
</div>    